const base = (import.meta.env.VITE_FACE_MODEL_BASE_URL as string | undefined) ?? '/models';

export const faceModelUrls = {
  scrfd:         `${base}/scrfd_500m.onnx`,
  mobilefacenet: `${base}/mobilefacenet.onnx`,
  minifasnetv2:  `${base}/minifasnetv2.onnx`,
} as const;
